import React, { useState } from "react"
import { Card, CardBody, Collapse } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import ReportTable from "components/Common/ReportTable"
import MonitorQuantificationFilter from "./filter"

const MonitorQuantificationReportListComponent = ({
  data,
  loading,
  onExportBtnClick,
  onSearchHandler,
  exportStatus,
  columns,
  visibleColumns,
  onToggleColumn,
}) => {
  const [filterOpen, setFilterOpen] = useState(false)

  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  const onAdvancedSearchSubmit = searchData => {
    onSearchHandler(searchData)
  }

  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={loading}
          title={"Quantification Report"}
          lgColumn={8}
          exportBtn={true}
          exportBtnLoading={exportStatus?.loading}
          onExportBtnClick={onExportBtnClick}
          searchBox={false}
          rightBtn={false}
          advnacedSearchBtn={true}
          advnacedSearchBtnTitle={"Filter"}
          onAdvancedSearch={onAdvancedSearchHandler}
        />
        <Collapse isOpen={filterOpen}>
          <MonitorQuantificationFilter
            loading={loading}
            onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            columns={columns}
            onToggleColumn={onToggleColumn}
          />
        </Collapse>

        <ReportTable
          visibleColumns={visibleColumns}
          data={data?.data || data}
          loading={loading}
        />
      </CardBody>
    </Card>
  )
}

export default MonitorQuantificationReportListComponent
